var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconChat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 40,
    width: 40,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.833 22.5h11.584v-1.417H10.833Zm0-5.125h18.334v-1.417H10.833Zm0-5.125h18.334v-1.417H10.833ZM5 33.458V7.417q0-1 .708-1.709Q6.417 5 7.417 5h25.166q1 0 1.709.708.708.709.708 1.709v18.5q0 1-.708 1.708-.709.708-1.709.708H10.125Zm1.417-3.416L9.5 26.917h23.083q.417 0 .709-.292.291-.292.291-.708v-18.5q0-.417-.291-.709-.292-.291-.709-.291H7.417q-.417 0-.709.291-.291.292-.291.709Zm0-22.625v-1 23.625Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconChat);
export default __webpack_public_path__ + "static/media/icon-chat.e4d89f2e87daa3ada35d39fc22b77fc3.svg";
export { ForwardRef as ReactComponent };